export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-tablet-portrait-3f2fe6e01d8a097529ba677a017aaaf2.svg";